export default __webpack_public_path__ + "static/media/youtube.6f97e700.png";